import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Snackbar } from '@mui/material';
import COLORS from 'theme/colors';
import SiblingAvatar from './SiblingAvatar';
import { useSiblings } from './useSiblings';
import { formatSiblingName } from './siblingProfile';
import ChildNameHeading from './ChildNameHeading';

/**
 * MM-1123: dashboard heading naming the child whose profile is open ("Emma's Dashboard") instead of
 * greeting the guardian, with the yellow underline beneath the child's name ("Dashboard" when no
 * first name has been entered). It follows every child switch, after which a confirmation
 * ("Now viewing Emma Thompson") is shown.
 */
const DashboardGreeting = () => {
  const location = useLocation();
  const { siblings, activeSibling } = useSiblings();
  /** Whether the "Now viewing" confirmation is showing. */
  const [showSwitched, setShowSwitched] = useState(false);

  useEffect(() => {
    if ((location.state as any)?.switchedSibling) {
      setShowSwitched(true);
    }
  }, [location.key, location.state]);

  return (
    <>
      {/* MM-1123: "Emma's Dashboard", or "Dashboard" when no child name was entered at sign-up */}
      <ChildNameHeading title='Dashboard' />
      <Snackbar
        open={showSwitched && Boolean(activeSibling)}
        autoHideDuration={4000}
        onClose={() => setShowSwitched(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Box
          component='output'
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            px: 2.5,
            py: 1.75,
            borderRadius: '10px',
            background: COLORS.DarkBlue,
            color: COLORS.White,
            textTransform: 'none',
            fontSize: 15,
          }}
        >
          <SiblingAvatar sibling={activeSibling} siblings={siblings} size={28} />
          <span>
            Now viewing <strong>{formatSiblingName(activeSibling)}</strong>
          </span>
        </Box>
      </Snackbar>
    </>
  );
};

export default DashboardGreeting;
